/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ReturnPolicyType = {
  None: "none",
  ExchangeOnly: "exchangeOnly",
  WithinThirtyDays: "withinThirtyDays",
  Other: "other",
} as const;
export type ReturnPolicyType = ClosedEnum<typeof ReturnPolicyType>;

/** @internal */
export const ReturnPolicyType$inboundSchema: z.ZodNativeEnum<
  typeof ReturnPolicyType
> = z.nativeEnum(ReturnPolicyType);
/** @internal */
export const ReturnPolicyType$outboundSchema: z.ZodNativeEnum<
  typeof ReturnPolicyType
> = ReturnPolicyType$inboundSchema;
